import React from 'react'

export default function Label({ isInvalid, text, ...rest }) {
    return (
        <label className={isInvalid && 'font-size-13 error-text'} {...rest}>{text}</label>
    );
}
